export default "__VITE_ASSET__DE75MqRC__"